import { Icon } from '@iconify/react';
import { useTranslation } from 'react-i18next';
import { productTypeState } from 'recoil/productTypeState';
import { useRecoilValue } from 'recoil';
import { ProductType } from '../@types/model/productType';

export interface GridInfoProps {
  label: string;
  value: string | null;
  edit: boolean | null;
  onEdit: () => void;
}

const GridInfo = (props: GridInfoProps) => {
  const productTypes: ProductType[] = useRecoilValue(productTypeState);
  const { t } = useTranslation();
  let newValue = props.value;
  if (props.label === t('feed_type')) {
    productTypes.forEach((pt) => {
      if (pt.guid === props.value) {
        newValue = pt.name;
      }
    });
  }
  return (
    <div className="gridInfo">
      <div className="label">{props.label}</div>
      <div className="value">{newValue ? newValue : '-'}</div>
      {props.edit ? (
        <Icon icon={'bi:pencil'} className="icon" onClick={() => props.onEdit()} />
      ) : null}
    </div>
  );
};
export default GridInfo;
